import { render, staticRenderFns } from "./layouts.error.1e1c42dd.vue?vue&type=template&id=9d18d470"
import script from "./layouts.error.1e1c42dd.vue?vue&type=script&lang=js"
export * from "./layouts.error.1e1c42dd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports